module.exports = __webpack_public_path__ + "img/new.43d0f324.svg";